import { z } from 'zod'

export const activateSearchSchema = z.object({
  language: z.string().optional()
})
